import { updateGallery } from '@wix/ambassador-progallery-v1-gallery/http';
import { State } from '@wix/ambassador-progallery-v1-gallery/types';
export const updateGalleryItems = async (httpClient, errorHandler, galleryId, items) => {
  const {
    withErrorHandler
  } = errorHandler;
  try {
    const {
      data: {
        gallery
      }
    } = await withErrorHandler(async () => httpClient.request(updateGallery({
      gallery: {
        id: galleryId,
        items
      },
      state: State.SAVED
    })), {
      errorCodesMap: {}
    });
    return gallery;
  } catch (error) {
    throw error;
  }
};
//# sourceMappingURL=update-gallery-items.js.map